<!-- Asientos Mini bus -->
<div class="col-lg-12 pt-4">
  <div class="ps-4 pt-5 pb-4 bg-grey pe-4 radius-30">
    <div class="row mb-4">
      <div class="col-xxl-4 col-lg-12 col-12">
        <h3 class="mb-3 mb-xxl-0 text-center text-lg-start">Ubicación de asientos</h3>
      </div>
      <div class="col-xxl-8 col-lg-12 col-12 planta-alta">
        <div class="buss">
          <ol class="cabin fuselage">
            <li class="row row--1">
              <ol class="seats" type="A">
                <li class="seat" [ngClass]="checkAsientoReserva('01') || bloquear?'disable-checkbox':''">
                  <div class="cover"></div>
                  <input type="checkbox" id="01" [checked]="checkAsiento('01') || checkAsientoSelected('01')" (change)="revisarCambio('01')"  />
                  <label for="01">01</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('05')|| bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="05" [checked]="checkAsiento('05') || checkAsientoSelected('05')" (change)="revisarCambio('05')"  />
                  <label for="05">05</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('09') || bloquear?'disable-checkbox':''">
                  <div   class="cover"></div>
                  <input type="checkbox" id="09" [checked]="checkAsiento('09') || checkAsientoSelected('09')" (change)="revisarCambio('09')" />
                  <label for="09">09</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('13') || bloquear?'disable-checkbox':''">
                  <div class="cover"></div>
                  <input type="checkbox" id="13" [checked]="checkAsiento('13') || checkAsientoSelected('13')" (change)="revisarCambio('13')" />
                  <label for="13">13</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('17') || bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="17" [checked]="checkAsiento('17') || checkAsientoSelected('17')" (change)="revisarCambio('17')" />
                  <label for="17">17</label>
                </li>
                <li class="seat " [ngClass]="checkAsientoReserva('21') || bloquear?'disable-checkbox':''">
                  <div class="cover"></div>
                  <input type="checkbox" id="21" [checked]="checkAsiento('21') || checkAsientoSelected('21')" (change)="revisarCambio('21')" />
                  <label for="21">21</label>
                </li>

              </ol>
            </li>
            <li class="row row--1">
              <ol class="seats" type="A">
                <li class="seat" [ngClass]="checkAsientoReserva('02') || bloquear?'disable-checkbox':''">
                  <div class="cover"></div>
                  <input type="checkbox" id="02" [checked]="checkAsiento('02') || checkAsientoSelected('02')" (change)="revisarCambio('02')" />
                  <label for="02">02</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('06') || bloquear?'disable-checkbox':''">
                  <div class="cover"></div>
                  <input type="checkbox" id="06" [checked]="checkAsiento('06') || checkAsientoSelected('06')" (change)="revisarCambio('06')" />
                  <label for="06">06</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('10') || bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="10" [checked]="checkAsiento('10') || checkAsientoSelected('10')" (change)="revisarCambio('10')" />
                  <label for="10">10</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('14') || bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="14" [checked]="checkAsiento('14') || checkAsientoSelected('14')" (change)="revisarCambio('14')" />
                  <label for="14">14</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('18') || bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="18" [checked]="checkAsiento('18') || checkAsientoSelected('18')" (change)="revisarCambio('18')" />
                  <label for="18">18</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('22') || bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="22" [checked]="checkAsiento('22') || checkAsientoSelected('22')" (change)="revisarCambio('22')" />
                  <label for="22">22</label>
                </li>

              </ol>
            </li>
            <li class="row row--2 mt-4">
              <ol class="seats" type="A">
                <li class="seat" [ngClass]="checkAsientoReserva('04') || bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="04" [checked]="checkAsiento('04') || checkAsientoSelected('04')" (change)="revisarCambio('04')" />
                  <label for="04">04</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('08') || bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="08" [checked]="checkAsiento('08') || checkAsientoSelected('08')" (change)="revisarCambio('08')" />
                  <label for="08">08</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('12') || bloquear?'disable-checkbox':''">
                  <div class="cover"></div>
                  <input type="checkbox" id="12" [checked]="checkAsiento('12') || checkAsientoSelected('12')" (change)="revisarCambio('12')" />
                  <label for="12">12</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('16') || bloquear?'disable-checkbox':''">
                  <div class="cover"></div>
                  <input type="checkbox" id="16" [checked]="checkAsiento('16') || checkAsientoSelected('16')" (change)="revisarCambio('16')" />
                  <label for="16">16</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('20') || bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="20" [checked]="checkAsiento('20') || checkAsientoSelected('20')" (change)="revisarCambio('20')" />
                  <label for="20">20</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('24') || bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="24" [checked]="checkAsiento('24') || checkAsientoSelected('24')" (change)="revisarCambio('24')" />
                  <label for="24">24</label>
                </li>

              </ol>
            </li>

            <li class="row row--2">
              <ol class="seats" type="A">
                <li class="seat" [ngClass]="checkAsientoReserva('03') || bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="03" [checked]="checkAsiento('03') || checkAsientoSelected('03')" (change)="revisarCambio('03')" />
                  <label for="03">03</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('07') || bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="07" [checked]="checkAsiento('07') || checkAsientoSelected('07')" (change)="revisarCambio('07')" />
                  <label for="07">07</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('11') || bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="11" [checked]="checkAsiento('11') || checkAsientoSelected('11')" (change)="revisarCambio('11')" />
                  <label for="11">11</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('15') || bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="15" [checked]="checkAsiento('15') || checkAsientoSelected('15')" (change)="revisarCambio('15')" />
                  <label for="15">15</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('19') || bloquear?'disable-checkbox':''">
                  <div  class="cover"></div>
                  <input type="checkbox" id="19" [checked]="checkAsiento('19') || checkAsientoSelected('19')" (change)="revisarCambio('19')" />
                  <label for="19">19</label>
                </li>
                <li class="seat" [ngClass]="checkAsientoReserva('23') || bloquear?'disable-checkbox':''">
                  <div class="cover"></div>
                  <input type="checkbox" id="23" [checked]="checkAsiento('23') || checkAsientoSelected('23')" (change)="revisarCambio('23')" />
                  <label for="23">23</label>
                </li>
              </ol>
            </li>

          </ol>
        </div>

      </div>
    </div>
    <div class="row mb-4">
      <div class="col-xxl-3 col-lg-12 col-12">
      </div>
      <div class="col-xxl-4 col-12 align-self-end">
        <div class="align-items-center d-flex flex-row justify-content-xxl-end mb-3">
          <p class="mb-0 pe-2">Asientos disponibles</p>
          <div class="unchecked"></div>
        </div>
        <div class="align-items-center d-flex flex-row justify-content-xxl-end ">
          <p class="mb-0 pe-2">Asientos no disponibles</p>
          <div class="checked"></div>
        </div>
      </div>
    </div>

  </div>
</div>
